module.exports = __webpack_public_path__ + "static/media/homeP.b58f064a.png";